import React, {useEffect} from 'react';
import {useFormik} from 'formik';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import actions from '../../../redux/actions';
import {connect} from 'react-redux';
import _ from 'lodash';
import './ResetPassRequest.scss';
import {useHistory} from 'react-router-dom';
import CustomInput from '../../../common/components/CustomInput/CustomInput';
import Button from "../../../common/components/Button/Button";

const InputErrorMessage = ({formik, name, className = ''}) => {
    const errorMessage = _.get(formik.touched, name) && _.get(formik.errors, name);
    return (
        <div className={className}>
            {errorMessage !== '' &&
                <div style={{marginTop: '5px'}}>
                    {errorMessage && _.capitalize(errorMessage)}
                </div>
        }
        </div>
    );
};

const _ResetPassRequest = ({resetPassEmail, resetPasswordEmailState, cleanResetPassEmailState, showSidebar}) => {
    const history = useHistory();

    const validationSchema = yup.object({
        email: yup
            .string('Ingrese email')
            .email('email invalido')
            .required('Ingrese email'),
    });

    useEffect(() => {
        if (resetPasswordEmailState?.success) {
          history.replace('/login');
          cleanResetPassEmailState();
        }
        // eslint-disable-next-line
    }, [resetPasswordEmailState?.success]);

    const formik = useFormik({
        initialValues: {
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                email: values.email,
            };
            resetPassEmail(body);
        },
    });

    return (
        <div className='reset-pass-container'>
                <div className="title-and-subtitle">
                    <p className="h3 v2-c-text-title">Cambio de contraseña</p>
                    <p className="body-1 subtitle">Ingrese una dirección de correo electrónico para poder
                                                cambiar su contraseña.</p>
                </div>
                <form className="recovery-form" onSubmit={formik.handleSubmit}>
                    <div className="recovery-mail-input">
                        <CustomInput label={'Mail'}
                                     placeholder={'Ingrese su mail'}
                                     value={formik.values.email}
                                     onChange={(value) => formik.handleChange({target: {name: 'email', value}})}/>
                        <InputErrorMessage formik={formik} name='email' className='form-input-error' />
                    </div>
                    <Button type="submit" size="large">Enviar mail</Button>
                </form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    resetPasswordEmailState: state.login.resetPasswordEmailState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    logout: () => dispatch(actions.login.logout()),
    cleanResetPassEmailState: () => dispatch(actions.login.cleanResetPassEmailState()),
});


export default connect(mapStateToProps, mapDispatchToProps)(_ResetPassRequest);
